<template>
  <v-container fluid class="pa-0 ma-0">
    <v-dialog v-model="dialogEditor" fullscreen hide-overlay scrollable transition="dialog-bottom-transition" class="pa-0 ma-0">
      <v-card flat>
        <v-card-title>
          <span>Bearbeiten</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogEditor = false" color="black">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col class="pa-4" cols="12" xs="12">
              <v-select
                v-if="jsonResult && jsonResult.offerGallery"
                :items="jsonResult.offerGallery"
                v-model="selectedImage"
                item-text="pic"
                class="mx-2"
                outlined
                @change="updateImageIndex()"
                :item-value="(pic, index) => index"
                label="Bild auswählen"
                dense
              >
                <template v-slot:selection="data">
                  <div style="height:120px;margin-top: 10px;" class="justify-center">
                    <img :src="getImageUrl(data.item)" style="max-width: 160px; max-height: 120px; margin-right: 8px;" v-if="data.item" />
                  </div>
                </template>
                <template v-slot:item="data">
                  <div style="height:120px;margin-top: 10px;" class="justify-center">
                    <img :src="getImageUrl(data.item)" style="max-width: 160px; max-height: 120px; margin-right: 8px;" v-if="data.item"/>
                  </div>
                </template>
              </v-select>
            </v-col>
          </v-row>
           <v-row>
             <v-col v-if="editorFields">
               <v-simple-table>
                 <tbody>
                 <tr v-for="(value, index) in editorFields" :key="index">
                   <td v-if="editorFields[index].key === 'offerHost'" class="py-2">
                      <v-textarea auto-grow
                                  outlined :label="editorFields[index].key" v-model="editorFields[index].value" clearable></v-textarea>
                   </td>
                   <td v-else class="py-2"><v-text-field class="mt-4" outlined dense v-model="editorFields[index].value" :label="editorFields[index].key" clearable></v-text-field></td>
                 </tr>
                 </tbody>
               </v-simple-table>
             </v-col>
           </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="useEditorValues" color="primary" dark>Übernehmen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" fullscreen hide-overlay scrollable transition="dialog-bottom-transition" class="pa-0 ma-0">
      <v-card flat>
        <v-card-title>
          <span>Preview Ansicht</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false" color="black">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-img :src="dialogImage" contain max-height="100%" @click="dialog = false"></v-img>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="dialogImageisVertical" @click="download(offerImageUrlV, 'offer' + offerId + 'v.png')" icon><v-icon color="primary">cloud_download</v-icon></v-btn>
          <v-btn v-else @click="download(offerImageUrlH,'offer' + offerId + 'h.png')" icon><v-icon color="primary">cloud_download</v-icon></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row class="pa-4" v-if="errorResponse">
      <v-col v-if="!errorResponse.company">
        <span>Büro mit der id {{errorResponse.agencyId}}-{{officeId}} konnte nicht identifiziert werden. </span><br>
        <br>
        <span style="font-size: 14px">
        Sie sind noch nicht freigeschaltet.<br><br>
        Bitte nehmen Sie Kontakt mit Kermax Support auf:<br>
        TEL: 0851-9888-30<br>
        E-Mail: <a ref="mailto:support@kermax.de">support@kermax.de</a><br>
        </span>
        <br>
        <v-img
            :src="require('../../../assets/logo2.png')"
            class="mt-3"
            contain
            height="800"
        ></v-img>
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0 justify-center" v-if="showStage">
      <v-col style="max-width: 920px" cols="12" xs="12" class="pa-4 text-center" v-if="!doneAdd">
        <v-card class="pa-4" flat>
          <v-card-title v-if="false">
            <span style="font-size: 16px" :title="advisoryId + ' ' + offerId + ' ' + code">
              Möchten Sie dieses Angebot der Playliste hinzufügen?
            </span>
          </v-card-title>
          <v-card-text>
            <center>
              <table width="100%" style="" cellpadding="0" cellspacing="0">
              <tr>
                <td valign="middle">
                  <H2 style="border: 2px #808080 solid; border-radius: 10px; padding: 4px; margin-left: 8px; width: 140px">1. Vorschau</H2>
                </td>
                <td height="290" style="min-height: 290px;" align="center" v-if="selectedDevicesH && selectedDevicesH.length > 0">
                  <table>
                    <tr>
                      <td valign="top" height="255">
                        <v-img :src="offerImageUrlV" max-height="320" max-width="140"
                               @click="preview(true,offerImageUrlV)"></v-img>
                      </td>
                    </tr>
                    <tr>
                      <td align="right" style="background-color: white">
                        <v-btn @click="startEditor" color="primary" dark class="ml-2" v-if="isEditor" icon>
                          <v-icon color="primary">mdi-cog</v-icon>
                        </v-btn>
                        <v-btn @click="preview(true, offerImageUrlV)" icon>
                          <v-icon color="black" large>fullscreen</v-icon>
                        </v-btn>
                        <v-btn @click="download(offerImageUrlV, 'offer' + offerId + 'v.png')" icon>
                          <v-icon color="primary">cloud_download</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </table>
                </td>
                <td height="290"  style="min-height: 290px;" align="center" v-else>
                </td>
                <td  height="290" style="min-height: 290px;" align="center" v-if="selectedDevicesV && selectedDevicesV.length > 0">
                  <table>
                    <tr>
                      <td valign="top" height="255">
                        <v-img :src="offerImageUrlH" max-height="320" max-width="320"
                               @click="preview(true,offerImageUrlH)"></v-img>
                      </td>
                    </tr>
                    <tr>
                      <td align="right" style="background-color: white">
                        <v-btn @click="startEditor" color="primary" dark class="ml-2" v-if="isEditor" icon>
                          <v-icon color="primary">mdi-cog</v-icon>
                        </v-btn>
                        <v-btn @click="preview(false, offerImageUrlH)" icon>
                          <v-icon color="black" large>fullscreen</v-icon>
                        </v-btn>
                        <v-btn @click="download(offerImageUrlH,'offer' + offerId + 'h.png')" icon>
                          <v-icon color="primary">cloud_download</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </table>

                </td>
                <td height="290"  style="min-height: 290px;" align="center" v-else>
                </td>
              </tr>
              <tr style="background-color: #b2b2b2">
                <td valign="middle" width="280">
                  <H2 style="border: 2px #808080 solid; border-radius: 10px; padding: 4px; margin-left: 8px; width: 240px">2. Screens auswählen</H2>
                </td>
                <td style="background-color: #b2b2b2" colspan="2">
                  <table width="100%" style="background-color: #b2b2b2" >
                    <tr style="background-color: #b2b2b2" >
                      <td><v-select
                          class="mx-2"
                          v-model="selectedDevices"
                          :items="devices"
                          deletable-chips
                          chips
                          item-value="guid"
                          item-text="name"
                          multiple
                      ></v-select></td>
                    </tr>
                    <!--
                    <tr style="background-color: #b2b2b2" >
                      <td align="right"><h3>Hochformat:</h3></td>
                      <td><v-select
                          class="mx-2"
                          v-model="selectedDevicesH"
                          :items="devicesH"
                          deletable-chips
                          chips
                          style="width: 280px"
                          item-value="guid"
                          item-text="name"
                          multiple
                      ></v-select></td>
                    </tr>
                    <tr style="background-color: #b2b2b2" >
                      <td align="right"><h3>Querformat:</h3></td>
                      <td> <v-select
                          class="mx-2"
                          v-model="selectedDevicesV"
                          :items="devicesV"
                          deletable-chips
                          chips
                          style="width: 280px"
                          item-value="guid"
                          item-text="name"
                          multiple
                      ></v-select></td>
                    </tr>
                    -->
                  </table>
                </td>
              </tr>
              <tr>
                <td valign="middle">
                  <H2 style="border: 2px #808080 solid; border-radius: 10px; padding: 4px; margin-left: 8px; width: 140px">3. Gültigkeit</H2>
                </td>
                <td colspan="2" class="pa-4 px-0">
                  <table cellpadding="0" cellspacing="0">
                    <tr>
                      <td><v-text-field @focus="$event.target.select()" v-model="formattedDatetime" dense hide-details label="von" class="mx-2" style="max-width: 100px"></v-text-field></td>
                      <td><v-text-field @focus="$event.target.select()" v-model="formattedDatetimeTill" dense hide-details label="bis" class="mx-2" style="max-width: 100px"></v-text-field></td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
            </center>
          </v-card-text>
          <v-card-actions>
            <v-tooltip top v-if="!isBOSIS && false">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" @click="removeAddress" color="secondary" dark class="ml-2" small>Adresse entfernen</v-btn><br>
              </template>
              <span>Entfernt die Adresse im Angebot</span>
            </v-tooltip>
            <!--
            <v-icon @click="startEditor" color="primary">mdi-cog</v-icon>
            <v-btn @click="startEditor" color="primary" dark class="ml-2" v-if="isEditor">Text bearbeiten</v-btn>
            -->
            <!--<v-btn @click="toPortal" color="primary" dark>Kermax Portal</v-btn>-->
            <v-spacer></v-spacer>
            <span style="color:red" v-if="dateMessage && dateMessage.length>0">{{dateMessage}}</span>
            <v-spacer v-if="dateMessage && dateMessage.length>0"></v-spacer>
            <v-btn @click="addOfferId" color="primary" dark class="ml-2">Angebot hinzufügen</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col style="max-width: 920px" cols="12" xs="12" class="pa-4 text-center" v-else>
        <v-card class="pa-4" v-if="doneAddSuccess">
          <v-card-title>
            <span style="font-size: 16px">Angebot wurde der Playlist hinzugefügt.</span>
          </v-card-title>
          <v-card-text>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="toPortal" color="primary" dark>Kermax Portal</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
        <v-card class="pa-4" v-else>
          <v-card-title>
            <span style="font-size: 16px">              Angebot konnte keiner Playlist hinzugefügt werden.</span>
          </v-card-title>
          <v-card-text>
            <span style="font-size: 12px; color:red" v-if="!addResult">
              Keine Antwort vom Server.<br>
            </span>
            <span style="font-size: 12px; color:red" v-if="addResult && !addResult.company">
              Es konnte kein Netzwerk für {{advisoryId}} gefunden werden.<br>

            </span>
            <span style="font-size: 12px; color:red" v-if="addResult && addResult.lists && addResult.lists.length <= 0">
              Keine mögliche Playlist gefunden. Horizontal wird benötigt.<br>
            </span>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="toPortal" color="primary" dark>Kermax Portal</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from "vue";
import moment from "moment";

export default {
  name: 'PaxConnect',
  components: {},
  data () {
    return {
      activeFrom: new Date().getTime(),
      activeTill: new Date().getTime(),
      offerImageUrlH: null,
      offerImageUrlV: null,
      dialog: false,
      dialogEditor: false,
      editorFields: null,
      dialogImage: null,
      dialogImageisVertical: false,
      agencyId: null,
      advisoryId: "QAGW-0656",
      templateGuid: null,
      jsonResult: null,
      officeId: null,
      rectId: null,
      taskFolder: null,
      cache: true,
      offerId: "139852256",
      selectedImage: null,
      code: "myCode",
      isEditor: true,
      host: "",
      playlistId: '',
      playlists: [],
      errorResponse: null,
      myParams: '',
      test: null,
      devices: [],
      selectedDevices: [],
      selectedDevicesH: [],
      selectedDevicesV: [],
      devicesH: [],
      devicesV: [],
      doneAdd: false,
      showStage: false,
      doneAddSuccess: false,
      cntPlaylistsAdded: 0,
      addResult: null,
      dateMessage: '',
      till: '2023-10-01T00:00:00',
      formattedDatetime: '01.09.2019',
      formattedDatetimeTill: '01.09.2019',
      provider: 'PAX',
      isBOSIS: false
    }
  },
  methods: {
    onGetResult: function (response) {
      if (!this.isBOSIS) {
        this.agencyId = response.agencyId
      }
      this.till = response.till
      if (!response.imageV) {
        response.imageV = ""
      }
      if (!response.imageH) {
        response.imageH = ""
      }
      this.offerImageUrlV = Vue.prototype.$config.HOST + "" + response.imageV.replaceAll('public', '') + "?time=" + new Date().getTime()
      this.offerImageUrlH = Vue.prototype.$config.HOST + "" + response.imageH.replaceAll('public', '') + "?time=" + new Date().getTime()
      this.showStage = true
      if (this.isEditor) {
        this.loadOffer()
      }
    },
    loadOffer: function () {
      Vue.prototype.$apiPaxConnect.getOffer({
        advisoryId: this.advisoryId,
        provider: this.provider,
        offerId: this.offerId,
        officeId: this.officeId,
        rectId: this.rectId,
        isChannel: false,
        cache: this.cache,
        templateGuid: this.templateGuid,
        code: this.code
      }, this.onGetOfferData)
    },
    onGetOfferData: function (res) {
      this.jsonResult = res
    },
    updateImageIndex: function() {
      let value = this.selectedImage;
      let index = 0;
      if (value && this.jsonResult && this.jsonResult.offerGallery) {
        index = this.jsonResult.offerGallery.indexOf(value);
      }
      if (this.editorFields && this.editorFields.length > 0) {
        for (let i in this.editorFields) {
          if (this.editorFields[i].key === 'imageIndex') {
            this.$set(this.editorFields[i], 'value', index)
          }
        }
      }
    },
    readSelectedImage: function() {
      this.selectedImage = null;
      let index = 0;
      if (this.editorFields && this.editorFields.length > 0) {
        for (let i in this.editorFields) {
          if (this.editorFields[i].key === 'imageIndex') {
            if (this.jsonResult && this.jsonResult.offerGallery) {
              index = this.editorFields[i].value;
              this.selectedImage = this.jsonResult.offerGallery[index];
            }
          }
        }
      }
    },
    getImageUrl: function(url) {
      if (!url || url.length <= 0) {
        return ''
      }
      return url.replace(/180322/g, "209604") + '?t=' + new Date().getTime();
    },
    onFailedCode: function (response) {
      console.log(response)
      this.errorResponse = response
      // window.open("https://www.kermax.de/paxlounge", "_self")
      return
    },
    onGetLogin: function (response) {
      if (!response.company) {
        this.onFailedCode(response)
        return
      }
      if (response.company.legacy === 0) {
        const routeParams = this.$route.query || {}
        this.offerId = routeParams.offerId || this.offerId
        this.advisoryId = routeParams.advisoryId || this.advisoryId
        this.code = routeParams.code || this.code
        this.provider = routeParams.provider || this.provider
        this.officeId = routeParams.officeId || routeParams.officeID || this.officeId
        this.rectId = routeParams.rectId || routeParams.rectID || routeParams.recID || this.rectId
        this.sessionId = routeParams.sessionId || routeParams.sessionID || this.sessionId
        this.cache = routeParams.cache === '1'

        const url = new URL('/offer/send', window.location.origin)
        const redirectParams = {
          provider: this.provider,
          code: this.code,
          offerId: this.offerId,
          advisoryId: this.advisoryId,
          officeId: this.officeId,
          rectId: this.rectId,
          sessionId: this.sessionId,
        }

        Object.keys(redirectParams).forEach((key) => {
          if (redirectParams[key]) {
            url.searchParams.set(key, redirectParams[key])
          }
        })
        console.log('redirecting to', url.toString())
        window.location.assign(url.toString())
        return
      }
      this.playlists = response.playlists
      this.devices = response.devices
      this.selectedDevices = []
      this.selectedDevicesH = []
      this.selectedDevicesV = []
      this.taskFolder = response.json.task_folder

      if (this.devices) {
        for (let i in this.devices) {
          this.selectedDevices.push(this.devices[i].guid)
          if (this.devices[i].orientation === 'horizontal') {
            this.devicesV.push(this.devices[i])
            this.selectedDevicesV.push(this.devices[i].guid)
          } else {
            this.devicesH.push(this.devices[i])
            this.selectedDevicesH.push(this.devices[i].guid)
          }
        }
      }
      if (this.playlists && this.playlists.length > 0) {
        this.playlistId = this.playlists[0].guid
      }
      if (this.isBOSIS) {
        if (response.agencyId) {
          this.agencyId = response.agencyId
        }
      }
      if (!this.isBOSIS) {
        try {
          this.activeTill = moment(response.from).toDate()
          this.activeTill = new Date(this.activeTill.getTime() - 1000 * 60 * 60 * 24 * 7)

          const diff = this.activeTill.getTime() - this.activeFrom.getTime();
          const daydiff = diff / (1000 * 60 * 60 * 24);
          if (daydiff < 7) {
            this.activeTill = moment(response.start).toDate()
          }
          this.formattedDatetimeTill = moment(this.activeTill).format("DD.MM.YYYY")
        } catch (e) {
          console.error(e)
        }
      }
      let templateGuid = undefined
      if (response.company && response.company.templateId) {
        templateGuid = response.company.templateId
      }

      if (!templateGuid && response.defaultGuid && response.defaultGuid.length > 0) {
        templateGuid = response.defaultGuid
      }
      this.templateGuid = templateGuid

      Vue.prototype.$apiPaxConnect.requestOfferImage({
        advisoryId: this.advisoryId,
        provider: this.provider,
        offerId: this.offerId,
        officeId: this.officeId,
        rectId: this.rectId,
        isChannel: false,
        cache: this.cache,
        templateGuid: templateGuid,
        code: this.code
      }, this.onGetResult)
    },
    preview: function (isVertical, url) {
      this.dialogImageisVertical = isVertical
      this.dialogImage = url
      this.dialog = true
      console.log('url', url);
    },
    download: function (url, filename) {
      try {
        fetch(url)
            .then(response => response.blob())
            .then(blob => {
              const link = document.createElement("a");
              link.href = URL.createObjectURL(blob);
              link.download = filename;
              link.click();
            })
            .catch(console.error);
      } catch (e) {
        console.error(e)
      }
    },
    onGetResultAdd: function (response) {
      console.log('onGetResultAdd', response)
      this.doneAdd = true;
      this.addResult = response;
      this.doneAddSuccess = response.listsH.length > 0 || response.listsV.length > 0;
      this.cntPlaylistsAdded = response.listsH.length + response.listsV.length;
    },
    isValidDate: function(d) {
      return d instanceof Date && !isNaN(d);
    },

    removeAddress: function () {
      Vue.prototype.$apiPaxConnect.requestOfferImage({
        advisoryId: this.advisoryId,
        provider: this.provider,
        offerId: this.offerId,
        cache: false,
        officeId: this.officeId,
        rectId: this.rectId,
        isChannel: true,
        templateGuid: this.templateGuid,
        code: this.code
      }, this.onGetResult)
    },
    addOfferId: function (response) {
      console.log('addOfferId', response.image)
      const start = moment(this.formattedDatetime, "DD.MM.YYYY").toDate();
      const end = moment(this.formattedDatetimeTill, "DD.MM.YYYY").toDate();
      const targetTill = moment(this.till, "YYYY-MM-DD").toDate();

      this.dateMessage = ''
      const diffHours = Math.abs(start - end) / 36e5;
      if (diffHours < 12) {
        this.dateMessage = 'Der Abstand zwischen Start und Ende muss mindestens 12 Stunden haben'
        return
      }

      if (!this.isValidDate(start) || this.formattedDatetime.length < 9 || this.formattedDatetime.length > 10)  {
        this.dateMessage = 'Bitte prüfen Sie das Start Datum'
        return
      }
      if (!this.isValidDate(end) || this.formattedDatetimeTill.length < 9 || this.formattedDatetimeTill.length > 10)  {
        this.dateMessage = 'Bitte prüfen Sie das End Datum'
        return
      }


      if (!this.isBOSIS) {
        if (targetTill.getTime() < start.getTime()) {
          this.dateMessage = 'Das Abreisedatum muss größer als das Endatum Angebot sein. ' + moment(targetTill).format("DD.MM.YYYY");
          return
        }
        if (end.getTime() > targetTill.getTime()) {
          this.dateMessage = '"Aktiv bis" darf nicht grösser Abreisedatum sein. ' + moment(targetTill).format("DD.MM.YYYY");
          // Wenn activeTILL ist grösser als Abreisedatum dann activeTill ist Abreisedatum - 7 Tage
          this.formattedDatetimeTill = moment(targetTill).format("DD.MM.YYYY")
          return
        }
      }

      Vue.prototype.$apiPaxConnect.addOfferToOffice({
        start: start.getTime(),
        end: end.getTime(),
        targetDevices: this.selectedDevices,
        provider: this.provider,
        advisoryId: this.advisoryId,
        agencyId: this.agencyId,
        offerId: this.offerId
      }, this.onGetResultAdd)
    },
    decodeHtmlEntities: function(str) {
      if (!str) return str
      const txt = document.createElement('textarea')
      txt.innerHTML = str
      return txt.value
    },
    onEditorEdit: function (res) {
      this.editorFields = res
      if (this.editorFields && this.editorFields.length > 0) {
        for (let i in this.editorFields) {
          this.editorFields[i].value = this.decodeHtmlEntities(this.editorFields[i].value)
        }
      }
      this.readSelectedImage()
      this.dialogEditor = true
    },
    useEditorValues: function () {
      Vue.prototype.$apiPaxConnect.updateMode({
        mode: 'USE_EDITOR_VALUES',
        advisoryId: this.advisoryId,
        provider: this.provider,
        offerId: this.offerId,
        officeId: this.officeId,
        rectId: this.rectId,
        isChannel: false,
        cache: this.cache,
        templateGuid: this.templateGuid,
        code: this.code,
        taskFolder: this.taskFolder,
        editorFields: JSON.stringify(this.editorFields)
      }, this.onEditorValueSet)
    },
    onEditorValueSet: function (res) {
      console.log('onEditorValueSet', res)
      this.dialogEditor = false
      this.editorFields = null
      Vue.prototype.$apiPaxConnect.requestOfferImage({
        advisoryId: this.advisoryId,
        provider: this.provider,
        offerId: this.offerId,
        officeId: this.officeId,
        rectId: this.rectId,
        isChannel: false,
        cache: this.cache,
        templateGuid: this.templateGuid,
        code: this.code
      }, this.onGetResult)
    },
    startEditor: function () {
      this.selectedImage = this.jsonResult.offerGallery && this.jsonResult.offerGallery.length > 0 ? this.jsonResult.offerGallery[0] : null
      Vue.prototype.$apiPaxConnect.updateMode({
        mode: 'INIT_EDITOR',
        advisoryId: this.advisoryId,
        provider: this.provider,
        offerId: this.offerId,
        officeId: this.officeId,
        rectId: this.rectId,
        isChannel: false,
        cache: this.cache,
        templateGuid: this.templateGuid,
        code: this.code
      }, this.onEditorEdit)
    },
    toPortal: function() {
      window.location.href = "https://ds.kermax.tv/"
    },
    setDT (a) {
      var d = new Date(a)
      console.log(d.getTime())
    }
  },
  mounted () {
    if (this.$route.query && this.$route.query.advisoryId) {
      this.advisoryId = this.$route.query.advisoryId
    }
    if (this.$route.query && this.$route.query.code) {
      this.code = this.$route.query.code
    }
    // if (this.$route.query && this.$route.query.editor) {
    // this.isEditor = this.$route.query.editor
    // }
    this.isEditor = true
    if (this.$route.query && this.$route.query.offerId) {
      this.offerId = this.$route.query.offerId
    }
    if (this.$route.query && this.$route.query.provider) {
      this.provider = this.$route.query.provider
    }
    if (this.$route.query && this.$route.query.officeID) {
      this.officeId = this.$route.query.officeID
    }
    if (this.$route.query && this.$route.query.rectID) {
      this.rectId = this.$route.query.rectID
      this.offerId = this.rectId
    }
    if (this.$route.query && this.$route.query.recID) {
      this.rectId = this.$route.query.recID
      this.offerId = this.rectId
    }
    if (this.$route.query && this.$route.query.cache) {
      this.cache = this.$route.query.cache + '' === '1'
    }



    this.myParams = JSON.stringify(this.$route.query)

    this.activeFrom = new Date(new Date().getTime())
    this.activeTill = new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 7) // 7 Tage



    if (window.location.href.indexOf('/#/bs/') > -1) {
      this.activeFrom = new Date(new Date().getTime())
      this.activeTill = new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 14) // 14 Tage
      this.provider = 'BOSIS'
      this.isBOSIS = true
    }
    this.formattedDatetime = moment(this.activeFrom).format("DD.MM.YYYY")
    this.formattedDatetimeTill = moment(this.activeTill).format("DD.MM.YYYY")

    Vue.prototype.$apiPaxConnect.prepareLogin({
      advisoryId: this.advisoryId,
      provider: this.provider,
      offerId: this.offerId,
      officeId: this.officeId,
      rectId: this.rectId,
      code: this.code
    }, this.onGetLogin, this.onFailedCode)
  }
}
</script>

<style scoped>

.gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding-left: 14px;
  margin: 1em 0;
}
</style>
